module.exports = __webpack_public_path__ + "54f9f7106a1b0219342ef3311cd03b36.svg";